// Actions génériques ajoutées lors du passage EN-défaut (wizards : Continuer/Précédent).
export default {
  fr: {
    "actions.continue": "Continuer",
    "actions.previous": "Précédent",
    "actions.copyValue": "Copier {value}",
    "actions.copied": "Copié",
    "actions.showMore": "Afficher plus",
    "actions.showLess": "Afficher moins",
  },
  en: {
    "actions.continue": "Continue",
    "actions.previous": "Previous",
    "actions.copyValue": "Copy {value}",
    "actions.copied": "Copied",
    "actions.showMore": "Show more",
    "actions.showLess": "Show less",
  },
  es: {
    "actions.continue": "Continuar",
    "actions.previous": "Anterior",
    "actions.copyValue": "Copiar {value}",
    "actions.copied": "Copiado",
    "actions.showMore": "Mostrar más",
    "actions.showLess": "Mostrar menos",
  },
};
